import ReservationsListCard from "./reservationsListCard";

export default ReservationsListCard;
